import React, { ReactNode } from 'react';
import './screen-wrapper.scss';
import { Header, HeaderProps } from '../header/header';
import { UpdateBanner, useNetworkContext } from '../../network';
import { Toast } from '../../components';

export interface ScreenWrapperProps {
  containerClassName?: string;
  children: React.ReactNode;
  childrenClassName?: string;
  headerProps?: HeaderProps;
  headerExtra?: ReactNode;
  selectCheckbox?: ReactNode;
  chipFilters?: ReactNode;
  tabs?: ReactNode;
}

export const ScreenWrapper: React.FC<ScreenWrapperProps> = ({
  containerClassName = '',
  childrenClassName = '',
  children,
  headerProps,
  headerExtra,
  chipFilters,
  selectCheckbox,
  tabs,
}) => {
  const { isUpdateAvailable, triggerUpdate, updateState } = useNetworkContext();

  return (
    <div className={`screen-container ${containerClassName}`}>
      <div className="screen-header">
        <UpdateBanner
          visible={isUpdateAvailable}
          onUpdate={triggerUpdate}
          isUpdating={updateState === 'updating'}
        />
        {headerProps && <Header {...headerProps} />}
        {selectCheckbox}
        {tabs}
        {chipFilters}
        {headerExtra}
      </div>
      <div className={`screen-children ${childrenClassName} no-scroll`}>
        {children}
      </div>
      <Toast />
    </div>
  );
};
